(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-usp-bar"] && !Shopify.designMode) return;
  try {
    
  const marqueeiconwithtext = document.querySelector('.section-usp-bar');
  document.documentElement.style.setProperty('--marquee-height', `${marqueeiconwithtext.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();
})();
